import { render } from "./match-players.template.html?vue&type=template&id=15a532da&scoped=true"
import script from "./MatchPlayers.vue?vue&type=script&lang=ts"
export * from "./MatchPlayers.vue?vue&type=script&lang=ts"

import "./MatchPlayers.vue?vue&type=style&index=0&id=15a532da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15a532da"

export default script